import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[boiStickyRightPanel]'
})
export class StickyRightPanelDirective {
  private readonly boWindowsMinWidth = 1200;

  constructor(private readonly hostElement: ElementRef) {}

  @Input() topOffset = 60;

  @HostListener('window:scroll')
  onScrollEvent(): void {
    const fixableRightContentStyle = this.hostElement.nativeElement.querySelector('.fixable-right-content')?.style;
    if (!fixableRightContentStyle) {
      return;
    }
    if (this.isStickyPosition() && window.innerWidth >= this.boWindowsMinWidth) {
      fixableRightContentStyle.position = 'fixed';
      fixableRightContentStyle.top = `${this.topOffset}px`;
    } else {
      fixableRightContentStyle.position = 'relative';
      fixableRightContentStyle.top = '0';
    }
  }

  private getPosition(element): { x: number; y: number } {
    let xPosition = 0;
    let yPosition = 0;
    let localElement = element;

    while (localElement) {
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      xPosition += element.offsetLeft - element.scrollLeft + element.clientLeft;
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      yPosition += element.offsetTop - element.scrollTop + element.clientTop;
      localElement = localElement.offsetParent;
    }

    return { x: xPosition, y: yPosition };
  }

  private isStickyPosition(): boolean {
    const topStickyContent = document.querySelector('.sticky-content');

    return !(this.getPosition(topStickyContent).y > 0);
  }
}
